import IntegerInput from './integerInput';
import SelectMenu, { SelectMenuProps } from './select';
import { CheckboxList } from './checkboxList';

import { PointsProps } from '../../modules/points/types/types';
import { IntegerList } from './integerList';

export type DefaultPointsProps = {
  onChange: (point: PointsProps, value: string | number | string[]) => void;
  setInputsError?: (value: boolean) => void;
  value: string | number | string[];
  point: PointsProps;
};

type PointsUIProps = {
  dataType: string;
  inputProps: SelectMenuProps;
};

const getUI = (dataType: string, props: SelectMenuProps) => {
  switch (dataType?.toLocaleLowerCase()) {
    case 'enum16':
      return <SelectMenu {...(props as SelectMenuProps)} />;
    case 'bitfield':
    case 'bitfield16':
      return <CheckboxList {...(props as SelectMenuProps)} />;
    case 'bitsplit':
    case 'bitsplit16':
      return <IntegerList {...(props as DefaultPointsProps)} />;
    default:
      return <IntegerInput {...(props as DefaultPointsProps)} />;
  }
};

const PointsInputs: React.FC<PointsUIProps> = ({ dataType, inputProps }) => {
  return getUI(dataType, inputProps);
};

export default PointsInputs;
